<template>
  <div class="grid grid-cols-[repeat(6,1fr)] gap-2">
    <div
      v-for="(color, index) in allColors"
      :key="index"
      class="flex flex-col gap-1"
    >
      <div
        v-for="(shade, i) in Object.keys(color).filter(
          (key) => key === 'lighter' || key === 'lightest'
        )"
        :key="i"
      >
        <MarkerColorBox
          :color="{
            color: color.name,
            color_type: shade as EntryColorType,
          }"
          :checked="color.name === entry.color && shade === entry.color_type"
          :value="color.name"
          :isMenu="isMenu"
          @click="
            $emit('click', {
              color: color.name,
              color_type: shade as EntryColorType,
            })
          "
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { EntryColor, EntryColorType } from "~/models/IEntryColor";

interface ColorObject {
  color: EntryColor;
  color_type: EntryColorType;
}

interface Props {
  entry: ColorObject;
  isMenu?: boolean;
}

type Emits = {
  click: [color: ColorObject];
};

withDefaults(defineProps<Props>(), { isMenu: false });

defineEmits<Emits>();

const { allColors } = useEntryColors();
</script>
